<template>
  <div class="contact">
    <a-row>
      <a-col :xl="{ span: 8, offset: 3 }" :xs="{ span: 18, offset: 3 }" class="contact_left">
        <h4>Contact Details</h4>
        <p>We warmly welcome you to visit our factory.</p>
        <br />
        <span>
          <a-icon type="user" />&nbsp;&nbsp;Sales Director： Jane Feng
        </span>
        <span>
          <address>
            <a-icon type="contacts" />&nbsp;&nbsp;Huahong Road No.51, Zhouzhuang
            Town, Jiangyin, Wuxi, Jiangsu Province, China
          </address>
        </span>
        <a-icon type="phone" />&nbsp;&nbsp;
        <span>
          <a href="tel:86051086978858">+86-0510-86978858</a>
        </span>
        <br />
        <a-icon type="mail" />&nbsp;&nbsp;
        <span>
          <a href="mailto:sales6@cnsian.com">sales6@cnsian.com</a>
        </span>
      </a-col>
      <a-col :xl="{ span: 8, offset: 1 }" :xs="{ span: 18, offset: 3 }">
        <a-row>
          <a-col :span="24">
            <h3>
              Leave us your message
              <br />and we will get back to you ASAP
            </h3>
          </a-col>

          <!-- use free email service as formspree to receive submitted forms, you can also deploy the service(https://github.com/formspree/formspree) yourself -->
          <a-col>
            <a-form
              :form="form"
              id="contactForm"
              @submit="handleSubmit"
              action="https://formspree.io/sales6@cnsian.com"
              method="POST"
            >
              <a-form-item label="Name" :label-col="{ span: 4 }" :wrapper-col="{ span: 6 }">
                <a-input
                  v-decorator="[
                    'name',
                    {
                      rules: [
                        { required: true, message: 'Please input your name' }
                      ]
                    }
                  ]"
                  placeholder="Name"
                  name="name"
                ></a-input>
              </a-form-item>
              <a-form-item label="Email" :label-col="{ span: 4 }" :wrapper-col="{ span: 6 }">
                <a-input
                  v-decorator="[
                    'email',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your email address'
                        }
                      ]
                    }
                  ]"
                  placeholder="Email address"
                  name="email"
                ></a-input>
              </a-form-item>
              <a-form-item label="Subject" :label-col="{ span: 4 }" :wrapper-col="{ span: 15 }">
                <a-input
                  v-decorator="[
                    'subject',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your message title'
                        }
                      ]
                    }
                  ]"
                  placeholder="Message title"
                  name="subject"
                ></a-input>
              </a-form-item>
              <a-form-item label="Message" :label-col="{ span: 4 }" :wrapper-col="{ span: 15 }">
                <a-textarea
                  placeholder="Message"
                  :rows="5"
                  v-decorator="[
                    'message',
                    {
                      rules: [
                        { required: true, message: 'Please input your message' }
                      ]
                    }
                  ]"
                  name="messageBody"
                />
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 12, offset: 4 }">
                <a-button type="primary" html-type="submit">Submit</a-button>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Contact Us"
  },
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this)
    };
  },
  methods: {
    handleSubmit(e) {
      // e.preventDefault();
      this.form.validateFields((err, data) => {
        if (err) {
          e.preventDefault();
        }
        if (!err) {
          // console.log("Received values of form: ", values);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.contact {
  padding: 6em 0;

  .contact_left {
    margin-bottom: 2em;
    span {
      font-size: 17px;
    }
  }
}
</style>
